// @format
/* @flow */
import React from 'react';
import { Route } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
// import Typography from '@material-ui/core/Typography';

import List from './List';
import Detail from './Detail';

type Props = {
  collar: CollarState
};

const useStyles = makeStyles(theme => ({
  pageTitle: {
    textAlign: 'center'
  },
  container: {}
}));
const Bluefang = (props: Props) => {
  const classes = useStyles();
  return (
    <Container className={classes.container}>
      <Route
        exact
        path="/bluefang"
        render={routeProps => <List {...routeProps} {...props} />}
      />
      <Route
        path="/bluefang/detail/:id"
        render={routeProps => <Detail {...props} {...routeProps} />}
      />
    </Container>
  );
};
export default Bluefang;
